import React from 'react'
import './StoryCell.css'

const StoryCell = ({
    handleClick = () => { },
    imgTumblr,
    type = '',
    typeUrl,
    imgUrl,
    icon,
    text,
}) => {
    return (
        <div onClick={(e) => handleClick(e)} className={`content-history-cell ${type}`}>
            {imgTumblr &&
                <>
                    {typeUrl.includes('image') &&
                        < img className="img-history-cell" alt="" src={imgTumblr} />
                    }
                    {typeUrl.includes('video') &&
                        <video className="img-history-cell">
                            <source src={imgTumblr}></source>
                        </video>
                    }
                </>
            }
            {icon && icon}
            <div className={`content-footer-history-cell`}>
                <div className="text-footer-history-cell">{text}</div>
                {imgUrl && < img className="img-footer-history-cell" alt="" src={imgUrl} />}
            </div>
        </div >
    )
}

export default StoryCell
